import { Bestellung } from '@/modules/ewwms/models/Lager/BestellungenModels';
import { Listeartikel } from '@/modules/ewwms/models/Lager/ListeartikelModels';
import { ArchivComponenteFile } from '@/modules/ewwms/models/ArchivModels';

export type State = {
  bestellungen: Array<Bestellung>;
  paletten: Array<Listeartikel>;
  initDate: Date;
  bestellungDoc: ArchivComponenteFile | null;
};

export const state: State = {
  bestellungen: sessionStorage.getItem('bestellungen') != null ? JSON.parse(sessionStorage.bestellungen) : new Array<Bestellung>(),
  paletten: new Array<Listeartikel>(),
  initDate: new Date(),
  bestellungDoc: null,
};
